import * as React from "react";
export default class Checkbox extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let classes = this.props.selected ? "checkbox selected" : "checkbox";
        return (React.createElement("div", { className: classes, onClick: this.props.onClick }, this.props.selected ? React.createElement("i", { className: "fa fa-check" }) : null));
    }
}
;
//# sourceMappingURL=checkbox.js.map